import { FC } from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SkeletonBox from "@Components/SkeletonBox/SkeletonBox";

type Props = {
  programName?: string;
  isFetching?: boolean;
};

const ExchangeDetailsHeaderWeb: FC<Props> = ({ programName, isFetching }) => {
  const { t } = useTranslation();

  return (
    <Breadcrumb
      className="font-semibold!"
      classNames={{
        item: "flex! items-center!",
      }}
      items={[
        {
          title: <Link to="/points">{t("Menu.points")}</Link>,
        },
        {
          title: !isFetching ? <div className="font-bold!">{programName}</div> : <SkeletonBox className="h-5 w-20" />,
        },
      ]}
    />
  );
};

export default ExchangeDetailsHeaderWeb;
